<template>
    <div class="content">
        <h2 class="content_title">Lesson</h2>
        <div class="video_wrap video_overlay">
            <img v-if="maskShow"
                v-show="maskFlag"
                class="video_mask"
                :src="'./data/' + contents.currentSlide.imageMask" alt=""
                @click="clickMask"
            >
            <video id="aw-video"
                class="video-js vjs-16-9 vjs-big-play-centered vjs-default-skin"
                controls
                preload="auto"
                :poster="'../assets/images/video_ready.png'"
                data-setup='{ "aspectRatio":"640:267", "playbackRates": [1, 1.5, 2] }'
            >
            <source  :src="videoSource" :type="videoSourceType">
            <p class="vjs-no-js">
                영상을 보시려면, 브라우져를 업그레이드 하셔야 합니다.  
                <a href="http://videojs.com/html5-video-support/" target="_blank">HTML5 영상지원 체크</a>
            </p>
            </video>
        </div>
    </div>
</template>
<script>
import videojs from 'video.js'
export default {
    props : ['contents'],
    data(){
        return{
            video : {},
            maskFlag : true,
            videoInterval : null,
            firstView : true
        }
    },
    computed: {
        maskShow(){
            return (this.contents.currentSlide != null && this.contents.currentSlide.hasOwnProperty('imageMask'))
        },
        videoSource(){
            if(this.contents.currentSlide.source.indexOf("https://") != -1){
                return this.contents.currentSlide.source;
            }
            if(typeof settings !== 'undefined' && settings.videoSource != null){
                if(this.contents.currentSlide.hasOwnProperty('order') && this.contents.currentSlide.order != null){
                    var fileName = pad(this.contents.chapterId) + '_' + this.contents.currentSlide.order + '.mp4';
                }else{
                    var fileName = pad(this.contents.chapterId)+ '.mp4';
                }
                var suffix = (settings.videoSource.suffix == null) ? '' : settings.videoSource.suffix;
                return settings.videoSource.prefix + fileName + suffix;
            }
            return './videos/' + this.contents.currentSlide.source;
        },
        videoSourceType(){
            if(this.videoSource.indexOf("m3u8") != -1){
                return 'application/x-mpegURL';
            }
            return 'video/mp4';
        },
        cookieName(){
            return 'aw/' + this.contents.lectureCode + '/' + this.contents.chapterId + '/' + this.contents.slideNumber;
        }
    },
    methods: {
        clickMask(){
            this.maskFlag = false;
            this.video.play();
        },
        playerHandler(){
            this.videoInterval = setInterval(() => {
                $cookies.set(this.cookieName,this.video.currentTime());
            }, 30000);
        },
        init(){
            this.video = videojs('aw-video',{
                playbackRates : [.5,1,1.5,2],
                fluid : true,
                resizeManager : false,
            });
            //register event listener in case of when you need to use someday...
            this.video.ready( () => {
                this.video.on('play', () => {
                    this.playerHandler();
                });
                this.video.on('pause',() => {
                    clearInterval(this.videoInterval);
                });
                this.video.on('ended',() => {
                    clearInterval(this.videoInterval);
                    if(this.contents.currentSlide.autoNext == 'Y'){
                        this.$emit('nextPage',1);       
                    }else if (this.contents.currentSlide.autoNext == 'P'){
                        swal({
                            title: "알림",
                            text: "다음 페이지로 넘어가시겠습니까?",
                            icon: "info",
                            buttons: true
                        }).then((willUpdate) => {
                            if (willUpdate) {
                                this.$emit('nextPage',1);       
                            }
                        });
                    }
                });
                document.getElementById("aw-video").addEventListener('contextmenu',function(e){ e.preventDefault(); },false);
                //not working at chrome.. IE works fine
                if(!this.maskShow){
                    if($cookies.get(this.cookieName) != null && this.firstView){
                        this.firstView = false;
                        swal({
                            title : '알림',
                            text : '학습하신 적이 있습니다.\n 이어 보시겠습니까?',
                            buttons : true,
                            }).then( (will) => {
                                if(will){
                                    this.video.currentTime($cookies.get(this.cookieName));
                                    this.video.play();
                                }else{
                                    this.video.play();
                                }
                            })
                    }else{
                        this.video.play();
                    }
                }
            });
        }
    },
    mounted(){
        //init player after mounted
        this.init();
    }
}
</script>